import Page from "./../../components/page/PageContent/PageContent";
import Button from "components/ui/Button";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

export default function ErrorPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Page name="error" title={t("Errors.page.title")}>
      <p>
        <Trans
          i18nKey={"Errors.unexpectedError.description"}
          components={{ retry: <Button variant="plain" onClick={goBack} /> }}
        />
      </p>
    </Page>
  );
}
